import { useNavigate } from "react-router-dom";
import { extractTeamViewLink } from "../../components/entitiesReferences/InternalEntityLink";
import { teamService } from "../../services/teamService";
import { SystemEntityCollections } from "../../shared/enums/shared-enums";
import { Team, TeamFilters } from "../../types/team";
import { useEntityQueryClient } from "./entityQueryClient";
import { SnackbarAction } from "notistack";
import { Button } from "@mui/material";
import useTeamLogic from "../logic/teamLogic";

const useTeamQuery = (systemLanguageType: Team["system_language_type"]) => {
  const { defaultTeam, getDisplayName } = useTeamLogic(systemLanguageType);
  const navigate = useNavigate();
  return useEntityQueryClient<Team, TeamFilters>({
    service: teamService,
    collection: SystemEntityCollections.TEAM,
    defaultEntity: defaultTeam,
    snackbarDisplayName: getDisplayName,
    snackbarAction: (data: Team): SnackbarAction => (
      <Button
        variant="text"
        onClick={() => navigate(extractTeamViewLink(data))}
        sx={{ color: "white" }}
      >
        View Team
      </Button>
    ),
  });
};

export default useTeamQuery;
